import React, { Component } from 'react';
import Wrp from '../Wrp/Wrp';

class BootstrapColumn extends Component {
    
    render () {
        const column = this.props.column;
        return (
            <Wrp>
                <div className={column}>
                        {this.props.children}
                </div> 
            </Wrp>
        )
    }
}

export default BootstrapColumn;